"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";

export function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <Button
        onClick={scrollToTop}
        size="icon"
        className={cn(
          "rounded-full bg-[#6729FF] hover:bg-[#5220cc] text-white shadow-[0_0_20px_rgba(103,41,255,0.4)] transition-all duration-300",
          isVisible
            ? "opacity-100 translate-y-0 cursor-pointer"
            : "opacity-0 translate-y-10 pointer-events-none",
        )}
        aria-label="Retour en haut"
      >
        <ChevronUp className="h-6 w-6" />
      </Button>
    </div>
  );
}
